export const isSingleFileInText = (preview: string) => {
    const pattern = /^[\s\\n]*!\[.*?]\((.*?)\)[\s\\n]*$/
    const matches = preview.match(pattern)

    return matches !== null
}

export const isSingleStickerInText = (preview: string) => {
    const pattern = /^sticker\(id:[^)]+\)$/i
    const trimmed = preview.trim()

    return pattern.test(trimmed)
}

export const isStartWithButton = (preview: string) => {
    const pattern = /^`*buttons\([^)]+\)\s*::/i
    const trimmed = preview.trim()

    return pattern.test(trimmed)
}

export const trimEmptyLines = (text: string) => {
    const pattern = /^(?:[\\\s]*\n)+|(?:\n[\\\s]*)+$/g

    return text.replace(pattern, "")
}
